export default {"src":"/_next/static/media/creature.e268722d.svg","height":533,"width":600,"blurWidth":0,"blurHeight":0};